import DenominationBaseController from '../common/denomination.base.controller'

class DenominationAllController extends DenominationBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, DenominationService, Modal, $translate, $stateParams, $location) {

        super(Auth, $state, User, DenominationService, Modal, $translate, $stateParams, $location)

        this.loading = true
        this.denominations = []
        this.hasAcl = {}
        this.page = 1;
        this.total = 0;
        this.pageLimit = 10;
        this.maxPages = 10
        this.searchText = '';
        this.$location = $location;
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId
        }
        this.loadData()
    }

    edit(denomination) {
        this.$state.go('denomination.edit', ({
            id: denomination.id
        }))
    }

    delete(denomination) {
        if (this.allowOnlyOnce) return;
        this.allowOnlyOnce = true;
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${denomination.id}</strong>?`,
            callback: (({
                modal,
                $scope
            }) => {
                $scope.loading = true
                this.Service.remove(denomination.id, this.branchId)
                    .then((data) => {
                        this.allowOnlyOnce = false;
                        modal.close()
                        this.refresh()
                    })
            }),
            negative: (({
                modal,
              }) => {
                this.allowOnlyOnce = false;
                modal.close();
              }),
            type: 'danger'
        })
    }

    refresh() {
        this.loadData()
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData()
    }

    generateSearchObj() {
        return {
            queryText: '%' + this.searchText + '%',
            isQuery: false
        }
    }

    search() {
        this.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData()
    }

    // Load All Denominations
    loadData() {
        const searchObj = this.generateSearchObj();

        this.loading = true;
        this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
            .then((data) => {
                this.total = data.total;
                this.denominations = data.results;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                this.error = err.message;
            })
    }

}

export default DenominationAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/all/denomination.all.controller.js